import {writable} from "svelte/store";
import {buscarMarcajes, marcajes} from '../Api/trabajadores';
import axios from 'axios';

const estadoInicial = {
  cargando: true,
  error: null,
  listado: [],
  cancelToken: undefined
};

let ultimaFecha = null;

const store = writable(estadoInicial);

let cancelToken = axios.CancelToken.source();

export default {
  subscribe: store.subscribe,
  cargar: (id, mes, anio) => {
    if (ultimaFecha === `${mes}-${anio}`) {
      return;
    }
    ultimaFecha = `${mes}-${anio}`;

    store.update(() => estadoInicial);

    marcajes(id, mes, anio)
        .then(listado => store.update(valor => ({
          ...valor,
          listado: listado,
          error: false
        })))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => store.update(valor => ({...valor, cargando: false})));
  },
  actualiza(dia, marcaje, detail) {
    store.update(valores => ({
      ...valores,
      listado: valores.listado.map(d => {
        if (d === dia) {
          return {
            ...d,
            horas: d.horas.map(hora => {
              if (hora === marcaje) {
                return {
                  ...hora,
                  hora: detail.hora,
                  observaciones: detail.observaciones,
                  tipo: detail.tipo
                };
              }

              return hora;
            })
          };
        }

        return d;
      })
    }));
  },
  buscar: function(inicio, fin, trabajadores = null, tipoDeIncidencia = null, motivo = null, sede = null) {
    if (cancelToken) {
      cancelToken.cancel('Cancelado a propósito');
    }

    store.update(() => estadoInicial);
    cancelToken = axios.CancelToken.source();

    buscarMarcajes(inicio, fin, trabajadores, tipoDeIncidencia, motivo, sede, cancelToken)
        .then(listado => {
          store.update(valor => {
            return {
              ...valor,
              listado: listado,
              cargando: false,
              error: false
            };
          });
        })
        .catch(e => store.update(valor => {
          return {...valor, error: e};
        }))
        .finally(() => store.update(valor => ({...valor, cargando: false})));
  }
};